export default __webpack_public_path__ + "static/media/pdf_ico.52e44726.svg";